import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import homeVisualBreak from '../assets/home-visual-break.png';

const Home = () => {
    // SVG Icons
    const TenantRelationsIcon = () => (
        <svg className="service-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M32 16C36.4183 16 40 19.5817 40 24C40 28.4183 36.4183 32 32 32C27.5817 32 24 28.4183 24 24C24 19.5817 27.5817 16 32 16Z" fill="#FFFFFF" />
            <path d="M18 48C18 40.268 24.268 34 32 34C39.732 34 46 40.268 46 48" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" />
            <path d="M48 24H56" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M8 24H16" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );

    const MaintenanceIcon = () => (
        <svg className="service-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M22 42L16 48L22 54L28 48L22 42Z" fill="#FFFFFF" />
            <rect x="20" y="14" width="6" height="34" rx="1" transform="rotate(-45 23 31)" fill="#D4AF37" />
            <path d="M42 22L48 16L54 22L48 28L42 22Z" fill="#FFFFFF" />
            <rect x="34" y="26" width="6" height="26" rx="1" transform="rotate(45 37 39)" fill="#D4AF37" />
            <circle cx="32" cy="32" r="5" fill="#FFFFFF" stroke="#0A192F" strokeWidth="2" />
        </svg>
    );

    const FinancialsIcon = () => (
        <svg className="service-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <rect x="20" y="20" width="24" height="24" rx="2" stroke="#FFFFFF" strokeWidth="2" />
            <path d="M32 16V20" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 44V48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M16 32H20" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M44 32H48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M28 28L32 32L36 24" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26 36H38" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );


    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero">
                <div className="container hero-content">
                    <h1>Professional Management with Personal Attention</h1>
                    <p className="hero-sub">Experience you can rely on, service your tenants will appreciate.</p>
                    <div className="hero-cta">
                        <Link to="/contact" className="btn-primary">Get a Quote</Link>
                        <Link to="/services" className="btn-secondary">View Services</Link>
                    </div>
                </div>
            </section>

            {/* Intro Section */}
            <section className="section intro-section">
                <div className="container">
                    <div className="intro-grid">
                        <div className="intro-text">
                            <h2>Your Residents Deserve the Best</h2>
                            <p className="lead">We deliver responsive service that keeps tenants happy and buildings running smoothly.</p>
                            <br />
                            <p>
                                With more than 20 years of hands-on experience in property management, we've built our reputation from the ground up.
                                We've worked in every aspect of the industry – from day-to-day operations and tenant relations to maintenance oversight,
                                financial management, leasing and strategic planning.
                            </p>
                            <p>
                                Having partnered with both small local owners and large organizations across the southwestern region,
                                we bring broad perspective and deep practical knowledge to every property we manage.
                            </p>
                            <Link to="/contact" className="text-link">Learn more about our approach &rarr;</Link>
                        </div>
                        <div className="intro-highlight">
                            <div className="highlight-card">
                                <h3>Why Choose P&C?</h3>
                                <ul>
                                    <li>Hands-on residential management</li>
                                    <li>Transparent communication</li>
                                    <li>Dependable support</li>
                                    <li>Highest standards of care</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Visual Break Placeholder */}
            <div className="visual-break-placeholder">
                <img src={homeVisualBreak} alt="Luxury Property Management" className="visual-break-image" />
            </div>

            {/* Services Preview */}
            <section className="section services-preview">
                <div className="container text-center">
                    <h2>Comprehensive Management Services</h2>
                    <p className="section-sub">Protecting your investment and enhancing value.</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <TenantRelationsIcon />
                            <h3>Tenant Relations</h3>
                            <p>Building positive relationships and ensuring long-term tenancy through responsive service.</p>
                        </div>
                        <div className="service-card">
                            <MaintenanceIcon />
                            <h3>Maintenance</h3>
                            <p>Proactive oversight and efficient resolution of maintenance challenges.</p>
                        </div>
                        <div className="service-card">
                            <FinancialsIcon />
                            <h3>Financials</h3>
                            <p>Transparent reporting and strategic financial management for your property.</p>
                        </div>
                    </div>
                    <div style={{ marginTop: '2rem' }}>
                        <Link to="/services" className="btn-primary">Explore All Services</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
